import { X } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { CartItem, cartTotal, getCart, saveCart } from "../lib/cart";
import { Currency, formatMoney } from "../lib/currency";
import { t } from "../lib/i18n";

export default function CartDrawer({ open, onClose, currency }: { open: boolean; onClose: () => void; currency: Currency }) {
  const { lang = "en" } = useParams();
  const items = getCart();
  function update(item: CartItem, quantity: number) {
    saveCart(items.map((row) => row === item ? { ...row, quantity } : row).filter((row) => row.quantity > 0));
  }
  return (
    <aside className={`fixed inset-y-0 right-0 z-50 w-full max-w-md bg-white shadow-2xl transition ${open ? "translate-x-0" : "translate-x-full"}`}>
      <div className="flex items-center justify-between border-b p-4"><h2 className="text-lg font-bold">{t(lang, "cart")}</h2><button onClick={onClose}><X /></button></div>
      <div className="space-y-4 p-4">
        {items.map((item) => (
          <div key={`${item.productId}-${item.variantId || 0}`} className="flex gap-3">
            <img src={item.image || "/placeholder.webp"} className="h-20 w-20 rounded-md object-cover" />
            <div className="flex-1">
              <p className="font-semibold">{item.title}</p>
              <p className="text-sm text-slate-500">{formatMoney(item.price, currency)}</p>
              <div className="mt-2 flex items-center gap-2"><button className="btn-secondary px-3 py-1" onClick={() => update(item, item.quantity - 1)}>-</button><span>{item.quantity}</span><button className="btn-secondary px-3 py-1" onClick={() => update(item, item.quantity + 1)}>+</button></div>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-0 left-0 right-0 border-t bg-white p-4">
        <div className="mb-4 flex justify-between font-bold"><span>{lang === "zh" ? "总计" : "Total"}</span><span>{formatMoney(cartTotal(items), currency)}</span></div>
        <Link onClick={onClose} className="btn-primary w-full" to={`/${lang}/checkout`}>{t(lang, "checkout")}</Link>
      </div>
    </aside>
  );
}
